export function getEnvs() {
  const envs = {
    // in minutes
    autoLogout: process.env.REACT_APP_AUTO_LOGOUT,
    // autoLogout: 0.2,

    qrBase: process.env.REACT_APP_QR_BASE,
    surveyBase: process.env.REACT_APP_SURVEY_BASE,
    clientUrl: process.env.REACT_APP_CLIENT_URL,

    // GraphQL 백엔드 (기존)
    BackendUrl: `${process.env.REACT_APP_BACKEND_BASE}/graphql`,
    backendBaseUrl: process.env.REACT_APP_BACKEND_BASE,

    // V2 REST API 백엔드 (신규)
    v2BackendUrl:
      process.env.REACT_APP_V2_BACKEND_BASE || `https://api-dev-dot-cyren-backend.uc.r.appspot.com`,

    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    isProd: process.env.NODE_ENV === 'production',
    isDev: process.env.NODE_ENV === 'development',
    nodeEnv: process.env.NODE_ENV,
    appEnv: process.env.REACT_APP_APP_ENV,
    isStagingApp: process.env.REACT_APP_APP_ENV === 'staging',
    waitlistLink: process.env.REACT_APP_WAITLIST_LINK,

    tenantId: process.env.REACT_APP_TENANT_ID,

    auth: {
      google: process.env.REACT_APP_AUTH_GOOGLE,
      ms: process.env.REACT_APP_AUTH_MS,
    },
    msSSO: {
      clientId: process.env.REACT_APP_AUTH_MS_CLIENT_ID,
      tenantId: process.env.REACT_APP_AUTH_MS_TENANT_ID,
    },
    athena: {
      baseUrl: process.env.REACT_APP_ATHENA_BASE_URL,
      // QA/QC FIX: [CRITICAL] - API credentials exposed in client-side code
      // LOGIC ISSUE: API keys and practice IDs are exposed in browser environment variables, visible to all users and attackers
      // SOLUTION: Move sensitive credentials to server-side and create proxy endpoints:
      // 1. Create server endpoint: /api/athena/proxy that handles authentication
      // 2. Store credentials in server environment variables only
      // 3. Use session-based authentication for client requests
      // 4. Example: fetch('/api/athena/patients') instead of direct API calls
      // IMPACT: Exposed credentials can be used maliciously to access patient data, violating HIPAA compliance
      apiKey: process.env.REACT_APP_ATHENA_CLIENT_ID,
      practiceId: process.env.REACT_APP_ATHENA_PRACTICE_ID,
    },
  };

  // console.log('envs', envs);

  return envs;
}

const envs = getEnvs();
const appName = 'CyrenCare';

export function getTitle() {
  if (envs.isProd) {
    return appName;
  }

  return `${appName} (${envs.nodeEnv})`;
}

export default envs;
